exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nsvg[data-v-5f984718] {\r\n  display: inline-block;\r\n  vertical-align: baseline;\r\n  margin-bottom: -2px; /* yes, I'm that particular about formatting */\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5f984718","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/vue-beautiful-chat/src/components/IconBase.vue
// module id = 1876
// module chunks = 116